<template>
  <div class="home">
    <div class="twh-row1">
      <div class="row1-main">
        <div class="row1-text1">{{ text1 }}</div>
        <div class="row1-text2">{{ text2 }}</div>
        <div class="row1-text3">
          节点小宝依托全自主研发的 P2P
          技术，专注聚合异地设备、网络与服务，实现极致便捷的跨地域互联。无论是人、设备还是
          AI Agent，都能无缝协同，随时随地，一键开启轻松访问与高效办公。
        </div>
        <div class="row1-btn" @click="jumpDownload()">立即体验</div>
        <!--                <div class="row1-text4">文件闪电传 / 一键式备份 / 直连不限速</div>-->
        <div class="row1-items">
          <div class="row1-item">
            <div class="row1-item-text2">
              <div class="row1-item-text2s1">3</div>
              <div class="row1-item-text2s2">重</div>
            </div>
            <div class="row1-item-text3">全方位筑牢安全防线</div>
          </div>
          <div class="row1-item">
            <div class="row1-item-text2">
              <div class="row1-item-text2s1">1</div>
              <div class="row1-item-text2s2">秒级</div>
            </div>
            <div class="row1-item-text3">极速响应远程指令</div>
          </div>
          <div class="row1-item">
            <div class="row1-item-text2">
              <div class="row1-item-text2s1">8</div>
              <div class="row1-item-text2s2">年</div>
            </div>
            <div class="row1-item-text3">专注远程连接云服务</div>
          </div>
          <div class="row1-item">
            <div class="row1-item-text2">
              <div class="row1-item-text2s1">98</div>
              <div class="row1-item-text2s2">%</div>
            </div>
            <div class="row1-item-text3">主流设备广泛适配</div>
          </div>
        </div>
      </div>
    </div>
    <div class="twh-row2">
      <div class="row2-slide-a">
        <div class="row2-item" :style="{ '--count': 1 }">
          <div class="row2-item-in row2-item1"></div>
        </div>
        <div class="row2-item" :style="{ '--count': 2 }">
          <div class="row2-item-in row2-item2"></div>
        </div>
        <div class="row2-item" :style="{ '--count': 3 }">
          <div class="row2-item-in row2-item3"></div>
        </div>
        <div class="row2-item" :style="{ '--count': 4 }">
          <div class="row2-item-in row2-item4"></div>
        </div>
        <div class="row2-item" :style="{ '--count': 5 }">
          <div class="row2-item-in row2-item5"></div>
        </div>
        <div class="row2-item" :style="{ '--count': 6 }">
          <div class="row2-item-in row2-item6"></div>
        </div>
        <div class="row2-item" :style="{ '--count': 7 }">
          <div class="row2-item-in row2-item7"></div>
        </div>
        <div class="row2-item" :style="{ '--count': 8 }">
          <div class="row2-item-in row2-item8"></div>
        </div>
        <div class="row2-item" :style="{ '--count': 9 }">
          <div class="row2-item-in row2-item9"></div>
        </div>
        <div class="row2-item" :style="{ '--count': 10 }">
          <div class="row2-item-in row2-item10"></div>
        </div>
      </div>
      <div class="row2-slide-b">
        <div class="row2-item-b" :style="{ '--count': 1 }">
          <div class="row2-item-b-in row2-b-item1"></div>
        </div>
        <div class="row2-item-b" :style="{ '--count': 2 }">
          <div class="row2-item-b-in row2-b-item2"></div>
        </div>
        <div class="row2-item-b" :style="{ '--count': 3 }">
          <div class="row2-item-b-in row2-b-item3"></div>
        </div>
        <div class="row2-item-b" :style="{ '--count': 4 }">
          <div class="row2-item-b-in row2-b-item4"></div>
        </div>
        <div class="row2-item-b" :style="{ '--count': 5 }">
          <div class="row2-item-b-in row2-b-item5"></div>
        </div>
        <div class="row2-item-b" :style="{ '--count': 6 }">
          <div class="row2-item-b-in row2-b-item6"></div>
        </div>
        <div class="row2-item-b" :style="{ '--count': 7 }">
          <div class="row2-item-b-in row2-b-item7"></div>
        </div>
        <div class="row2-item-b" :style="{ '--count': 8 }">
          <div class="row2-item-b-in row2-b-item8"></div>
        </div>
        <div class="row2-item-b" :style="{ '--count': 9 }">
          <div class="row2-item-b-in row2-b-item9"></div>
        </div>
        <div class="row2-item-b" :style="{ '--count': 10 }">
          <div class="row2-item-b-in row2-b-item10"></div>
        </div>
      </div>
    </div>
    <!-- <div class="i2">
      <div class="text1 move">让网络互联变得简单易用</div>
      <div class="content">
        <div class="text2 move-right" id="typing15">{{ text15 }}</div>
        <p class="text3">
          即装即用的远程访问，支持内网穿透和异地组网。具备超快的连接速度，轻松组建安全可信的专用网。基于P2P点对点技术实现互联互通。应用场景：远程开发、远程剪辑、管理NAS设备、访问企业办公系统、Docker、SSH、RDP桌面、挂载共享文件。
        </p>
        <div class="more">
          <div class="more1">部署简单</div>
          <div class="more1 more2">安全稳定</div>
          <div class="more1 more3">服务保障</div>
          <div class="more1 more4">随时管理</div>
        </div>
      </div>
    </div> -->
    <div class="i2">
      <div class="text1 move">让网络互联变得简单易用</div>
      <div class="content">
        <!-- 直接写入静态文字，同时保留上移动画 -->
        <div class="text2 move move-delay-100">P2P穿透技术传输更极致</div>
        <p class="text3">
          即装即用的远程访问，支持内网穿透和异地组网。具备超快的连接速度，轻松组建安全可信的专用网。基于P2P点对点技术实现互联互通。
        </p>
      </div>
      <div class="submit-btn" @click="jumpDownload()">
        <span>立即体验</span>
        <img src="../assets/home/goto_icon.svg" />
      </div>
    </div>
    <div class="twh-row3">
      <div class="row3-main">
        <div class="row3-item1">
          <div class="row3-item1-text1 move">为什么选择我们</div>
          <div class="row3-item1-text2 move delay-100">
            超简单、超高速、超安全、超稳定的一站式远程访问神器
          </div>
        </div>
        <div class="row3-item row3-item-a">
          <div class="row3-left"></div>
          <div class="row3-texts-item1-text move-right" id="typing3">
            {{ text3 }}
            <div class="row3-texts-item1-text2">{{ text4 }}</div>
          </div>
          <div class="row3-texts-item2">{{ text5 }}</div>
          <div class="row3-texts-item3">
            一键远控家里NAS、公司电脑、管理Docker
          </div>
          <div class="row3-texts-item3">小白也能秒上手，界面特别简单</div>
          <div class="row3-texts-item3">没有公网 IP 也能秒连内网设备</div>
          <div class="row3-right-btn" @click="jumpDownload()">立即体验</div>
        </div>
        <div class="row3-item row3-item-b">
          <div class="row3-right"></div>
          <div class="row3-texts-item1-text move-right" id="typing6">
            {{ text6 }}
            <div class="row3-texts-item1-text2">{{ text7 }}</div>
          </div>
          <div class="row3-texts-item2">{{ text8 }}</div>
          <div class="row3-texts-item3">
            打破远程壁垒，直连突破传统限制，不限速快到飞起
          </div>
          <div class="row3-texts-item3">
            大文件传输、高清视频流播放、大型软件运行高速稳定
          </div>
          <div class="row3-texts-item3">
            直连不绕路，速度无束缚，远程管理有它在
          </div>
          <div class="row3-right-btn" @click="jumpDownload()">立即体验</div>
        </div>
        <div class="row3-item row3-item-a">
          <div class="row3-left row3-left2"></div>
          <div class="row3-texts-item1-text move-right" id="typing9">
            {{ text9 }}
            <div class="row3-texts-item1-text2">{{ text10 }}</div>
          </div>
          <div class="row3-texts-item2">{{ text11 }}</div>
          <div class="row3-texts-item3">
            三重认证筑高墙，账号密码、绑定设备、加密链路
          </div>
          <div class="row3-texts-item3">
            一次一密、动态密钥双管齐下、256 位加密筑牢传输防线
          </div>
          <div class="row3-texts-item3">
            支持国密加密体系，通过软密码模块为产品提供安全保障
          </div>
          <div class="row3-right-btn" @click="jumpDownload()">立即体验</div>
        </div>
        <div class="row3-item row3-item-b">
          <div class="row3-right row3-right2"></div>
          <div class="row3-texts-item1-text move-right" id="typing12">
            {{ text12 }}
            <div class="row3-texts-item1-text2">{{ text13 }}</div>
          </div>
          <div class="row3-texts-item2">{{ text14 }}</div>
          <div class="row3-texts-item3">从连接到操控，稳定是底线更是底气</div>
          <div class="row3-texts-item3">≈99% 连接成功率</div>
          <div class="row3-texts-item3">
            断点续连1 秒自动恢复连接，进度不丢失
          </div>
          <div class="row3-right-btn" @click="jumpDownload()">立即体验</div>
        </div>
      </div>
    </div>
    <div class="twh-row7">
      <div class="row7-title move">内网穿透与异地组网合二为一</div>
      <div class="row7-text move delay-100">轻松搞定多设备跨地域互联互通</div>
      <div class="row7-items move-right" id="movetop7">
        <div :class="{ 'row7-item': true, 'row7-item-tr': row7tr }">
          <div class="row7-item-text">内网穿透</div>
          <div class="row7-item-text2">
            零公网 IP + 零路由配置，一键映射端口，内网服务秒变外网可访问
          </div>
          <div class="row7-item-icon"></div>
        </div>
        <div :class="{ 'row7-item': true, 'row7-item-tr2': row7tr }">
          <div class="row7-item-text">异地组网</div>
          <div class="row7-item-text2">
            跨区域全时互联，设备自由访问，数据传输稳定可靠
          </div>
          <div class="row7-item-icon row7-item-icon2"></div>
        </div>
      </div>
    </div>
    <div class="twh-row4">
      <div class="row4-title move">工业级接入终端，多类型兼容适配</div>
      <div class="row4-items move-right" id="movetop4">
        <div :class="{ 'row4-item': true, 'row4-item-tr': row4tr }">
          <div class="row4-icon row4-icon1"></div>
          <div class="row4-text">Nas</div>
        </div>
        <div :class="{ 'row4-item': true, 'row4-item-tr2': row4tr }">
          <div class="row4-icon row4-icon2"></div>
          <div class="row4-text">Windows</div>
        </div>
        <div :class="{ 'row4-item': true, 'row4-item-tr3': row4tr }">
          <div class="row4-icon row4-icon3"></div>
          <div class="row4-text">Mac</div>
        </div>
        <div :class="{ 'row4-item': true, 'row4-item-tr4': row4tr }">
          <div class="row4-icon row4-icon4"></div>
          <div class="row4-text">手机</div>
        </div>
        <div :class="{ 'row4-item': true, 'row4-item-tr5': row4tr }">
          <div class="row4-icon row4-icon5"></div>
          <div class="row4-text">平板电脑PAD</div>
        </div>
        <div
          :class="{ 'row4-item row4-item-last': true, 'row4-item-tr6': row4tr }"
        >
          <div class="row4-icon row4-icon6"></div>
          <div class="row4-text">路由器</div>
        </div>
        <div
          :class="{ 'row4-item row4-item-last': true, 'row4-item-tr7': row4tr }"
        >
          <div class="row4-icon row4-icon7"></div>
          <div class="row4-text">Linux</div>
        </div>
        <div
          :class="{ 'row4-item row4-item-last': true, 'row4-item-tr8': row4tr }"
        >
          <div class="row4-icon row4-icon8"></div>
          <div class="row4-text">Docker</div>
        </div>
      </div>
      <div class="row4-notice">国产系统待上线，敬请期待...</div>
    </div>

    <!-- <div class="twh-row13">
      <div class="row13-title move">游戏串流</div>
      <div class="row13-text move delay-100">无需设置，登录即玩</div>
      <div class="row13-body">
        <div class="body-left"></div>
        <div class="body-right">
          <div class="right-item">
            <div class="item-icon-1 icon-02" style="height: 50px"></div>
            <div class="item-title">安装即组网兼容大部分串流软件</div>
          </div>
          <div class="right-item">
            <div class="item-icon-1 icon-03" style="height: 50px"></div>
            <div class="item-title">P2P直连通道理论可跑满上行带宽</div>
          </div>
          <div class="right-item">
            <div class="item-icon-1 icon-04" style="height: 50px"></div>
            <div class="item-title">无需公网IP，随时随地畅玩游戏</div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="chuanliu-row">
      <div class="chuanliu-row-title move">游戏串游，畅玩3A大作</div>
      <div class="chuanliu-text move delay-100">
        Moonlight + Sunshine，低时延高清
      </div>
      <div class="chuanliu-items move-right" id="movetopChuanliu">
        <div :class="{ 'chuanliu-item': true, 'chuanliu-item-tr': chuanliuTr }">
          <div class="chuanliu-item-icon chuanliu-item-icon-1"></div>
          <div class="chuanliu-item-text">
            跨区低延迟串流， 出差躺卧随时开黑
          </div>
        </div>
        <div
          :class="{ 'chuanliu-item': true, 'chuanliu-item-tr2': chuanliuTr }"
        >
          <div class="chuanliu-item-icon chuanliu-item-icon-2"></div>
          <div class="chuanliu-item-text">秒级游戏串流，远程操控如同本地</div>
        </div>
        <div
          :class="{ 'chuanliu-item': true, 'chuanliu-item-tr3': chuanliuTr }"
        >
          <div class="chuanliu-item-icon chuanliu-item-icon-3"></div>
          <div class="chuanliu-item-text">沉浸式低损耗传输，异地远程对战</div>
        </div>
        <div
          :class="{ 'chuanliu-item': true, 'chuanliu-item-tr4': chuanliuTr }"
        >
          <div class="chuanliu-item-icon chuanliu-item-icon-4"></div>
          <div class="chuanliu-item-text">
            支持的平台：PS5 / PS4、Xbox 、Steam
          </div>
        </div>
      </div>
      <img
        class="player-img move delay-200"
        src="../assets/player_control.png"
      />
    </div>
    <div class="twh-row6">
      <div class="row6-title move">远程文件随时下载</div>
      <div class="row6-text move delay-100">跨设备 "秒传"，速度超出想象</div>
      <div class="row6-items move-right" id="movetop6">
        <div :class="{ 'row6-item': true, 'row6-item-tr': row6Class }">
          <div class="row6-item-icon"></div>
          <div class="row6-item-text">设备自由互通互联</div>
          <div class="row6-item-text2">
            支持 NAS、Windows、macOS设备远程文件
          </div>
        </div>
        <div :class="{ 'row6-item': true, 'row6-item-tr': row6Class2 }">
          <div class="row6-item-icon row6-item-icon2"></div>
          <div class="row6-item-text">极致速度，文件秒传</div>
          <div class="row6-item-text2">
            依托全局域网技术，传输速度拉满千兆级别
          </div>
        </div>
        <div
          :class="{
            'row6-item row6-item-last': true,
            'row6-item-tr': row6Class3,
          }"
        >
          <div class="row6-item-icon row6-item-icon3"></div>
          <div class="row6-item-text">不止快传，更联动全场景</div>
          <div class="row6-item-text2">
            结合远程开机、远程观影、远程BT下载等功能，体验直接拉满
          </div>
        </div>
      </div>
    </div>
    <div class="twh-row5">
      <div class="row5-title move">远程桌面一触即达</div>
      <div class="row5-text move delay-100">毫秒级响应如同本地体验</div>
      <div class="row5-items move-right" id="movetop5">
        <div :class="{ 'row5-item': true, 'row5-item-tr': row5tr }">
          <div class="row5-item-text">极速传输引擎</div>
          <div class="row5-item-text2">20MB/s 瞬时传输</div>
          <div class="row5-item-icon"></div>
        </div>
        <div :class="{ 'row5-item row5-item2': true, 'row5-item-tr2': row5tr }">
          <div class="row5-item-text">多屏协同操控</div>
          <div class="row5-item-text2">跨系统无缝切换</div>
          <div class="row5-item-icon row5-item-icon2"></div>
        </div>
      </div>
    </div>
    <div class="twh-row8">
      <div class="row8-title move">应用场景</div>
      <div class="row8-tabs">
        <div
          :class="{ 'row8-tab': true, 'row8-tab-active': tab == 1 }"
          @mouseover="tabClick(1)"
        >
          相册备份
        </div>
        <div
          :class="{ 'row8-tab': true, 'row8-tab-active': tab == 2 }"
          @mouseover="tabClick(2)"
        >
          远程下载
        </div>
        <div
          :class="{ 'row8-tab': true, 'row8-tab-active': tab == 3 }"
          @mouseover="tabClick(3)"
        >
          远程游戏
        </div>
        <div
          :class="{ 'row8-tab': true, 'row8-tab-active': tab == 4 }"
          @mouseover="tabClick(4)"
        >
          远程办公
        </div>
        <div
          :class="{ 'row8-tab': true, 'row8-tab-active': tab == 5 }"
          @mouseover="tabClick(5)"
        >
          远程视频
        </div>
        <div
          :class="{
            'row8-tab row8-tab-last': true,
            'row8-tab-active': tab == 6,
          }"
          @mouseover="tabClick(6)"
        >
          远程Nas
        </div>
      </div>
      <div class="row8-item" v-if="tab == 1">
        <div class="row8-item-icon"></div>
        <div class="row8-item-texts">
          <div class="row8-item-text1">一键备份 释放手机空间</div>
          <div class="row8-item-text2">无需手动删减照片，自动增量备份</div>
          <div class="row8-item-text2">一键解决内存不足，防止内容重复</div>
          <a class="row8-item-btn" @click="goHelp" href="javascript:;"
            >查看教程</a
          >
        </div>
      </div>
      <div class="row8-item" v-if="tab == 2">
        <div class="row8-item-icon row8-item-icon2"></div>
        <div class="row8-item-texts">
          <div class="row8-item-text1">一键访问 跨设备文件随心传</div>
          <div class="row8-item-text2">无需数据线</div>
          <div class="row8-item-text2">多设备无缝对接</div>
          <div class="row8-item-text2">远程提取文件</div>
          <div class="row8-item-text2">办公娱乐更高效</div>
          <a class="row8-item-btn" @click="goHelp" href="javascript:;"
            >查看教程</a
          >
        </div>
      </div>
      <div class="row8-item" v-if="tab == 3">
        <div class="row8-item-icon row8-item-icon3"></div>
        <div class="row8-item-texts">
          <div class="row8-item-text1">远程畅玩3A大作</div>
          <div class="row8-item-text1 row8-item-text1-b">
            随时随地掌控游戏世界
          </div>
          <div class="row8-item-text2">跨设备无缝衔接</div>
          <div class="row8-item-text2">毫秒级响应速度</div>
          <div class="row8-item-text2">4K 高清画质呈现</div>
          <div class="row8-item-text2">简单几步即连</div>
          <a
            class="row8-item-btn row8-item-btn3"
            @click="goHelp"
            href="javascript:;"
            >查看教程</a
          >
        </div>
      </div>
      <div class="row8-item" v-if="tab == 4">
        <div class="row8-item-icon row8-item-icon4"></div>
        <div class="row8-item-texts">
          <div class="row8-item-text1">一键远控，随时随地高效办公</div>
          <div class="row8-item-text2">无需携带电脑，多设备秒连办公主机</div>
          <div class="row8-item-text2">
            远程调取 & 实时编辑 & 异地剪辑，文件协作更高效
          </div>
          <div class="row8-item-text2">全场景适配，办公自由随心</div>
          <a
            class="row8-item-btn row8-item-btn4"
            @click="goHelp"
            href="javascript:;"
            >查看教程</a
          >
        </div>
      </div>
      <div class="row8-item" v-if="tab == 5">
        <div class="row8-item-icon row8-item-icon5"></div>
        <div class="row8-item-texts">
          <div class="row8-item-text1">随时随地，畅享"近在眼前"的</div>
          <div class="row8-item-text1 row8-item-text1-b">视觉连接</div>
          <div class="row8-item-text2">高清视频画面流畅传输</div>
          <div class="row8-item-text2">远程查看家中摄像头画面</div>
          <div class="row8-item-text2">远程控制家里的设备</div>
          <a
            class="row8-item-btn row8-item-btn4"
            @click="goHelp"
            href="javascript:;"
            >查看教程</a
          >
        </div>
      </div>
      <div class="row8-item" v-if="tab == 6">
        <div class="row8-item-icon row8-item-icon6"></div>
        <div class="row8-item-texts">
          <div class="row8-item-text1">一键远程访问NAS</div>
          <div class="row8-item-text1 row8-item-text1-b">
            随时随地掌控你的数据宝库
          </div>
          <div class="row8-item-text2">无需繁琐设置，一键直连 NAS</div>
          <div class="row8-item-text2">
            自动同步 + 智能增量备份，数据安全更省心
          </div>
          <div class="row8-item-text2">多设备无缝访问，流畅堪比本地文件</div>
          <a
            class="row8-item-btn row8-item-btn4"
            @click="goHelp"
            href="javascript:;"
            >查看教程</a
          >
        </div>
      </div>
    </div>
    <div class="twh-row9">
      <div class="row9-icon">
        <div class="row9-text1 move">用节点小宝 体验超凡连接</div>
        <div class="row9-text2 move delay-100">智慧互联 易用快速</div>
        <div class="row9-text3 move delay-200">
          十分期待您来体验产品，无论您是远程开发、远程剪辑、远程下载、远程管理。
        </div>
        <div class="row9-text3 row9-text3-b move delay-200">
          节点小宝超凡的互联传输，助您置身快感之中。
        </div>
      </div>
    </div>
    <div class="twh-row10">
      <div class="row10-title move">来自真实用户的评价</div>
      <div class="row10-text move delay-100">
        因卓越的速度，获得了众多用户的喜爱与信赖
      </div>
      <div class="row10-slide-a">
        <div class="row10-item" :style="{ '--count2': 1 }">
          <div class="row10-item-icon"></div>
          <div class="row10-item-text1">Karl Yau</div>
          <div class="row10-item-text2">
            强烈推荐节点小宝给所有需要远程管理的朋友。它的内网穿透功能真的太强大了，无论在哪里都能轻松访问公司内网。
          </div>
        </div>
        <div class="row10-item" :style="{ '--count2': 2 }">
          <div class="row10-item-icon row10-item-icon2"></div>
          <div class="row10-item-text1">蜡笔</div>
          <div class="row10-item-text2">
            你们的产品太牛逼了，好方便啊，有他域名访问，以后连客户端都不用装了。
          </div>
        </div>
        <div class="row10-item" :style="{ '--count2': 3 }">
          <div class="row10-item-icon row10-item-icon3"></div>
          <div class="row10-item-text1">吴刚</div>
          <div class="row10-item-text2">
            异地组网的功能非常好，NAS一般都支持映射网络驱动器，只要启动节点小宝，远程的NAS就可以当做本机硬盘一样用了
          </div>
        </div>
        <div class="row10-item" :style="{ '--count2': 4 }">
          <div class="row10-item-icon row10-item-icon4"></div>
          <div class="row10-item-text1">柊下桜</div>
          <div class="row10-item-text2">
            这可能是我一直苦苦追求的理想中的工具！我就想要在外面用笔记本也可以访问家里的samba。
          </div>
        </div>
        <div class="row10-item" :style="{ '--count2': 5 }">
          <div class="row10-item-icon row10-item-icon5"></div>
          <div class="row10-item-text1">Jeemzz</div>
          <div class="row10-item-text2">
            节点小宝的稳定性令人印象深刻，无论是大规模数据传输还是长时间稳定运行，都能保持出色的性能，非常值得信赖。
          </div>
        </div>
        <div class="row10-item" :style="{ '--count2': 6 }">
          <div class="row10-item-icon row10-item-icon6"></div>
          <div class="row10-item-text1">Timymood</div>
          <div class="row10-item-text2">
            相较于其他同类产品，节点小宝的价格非常合理。它的功能和性能都超出了我的预期，而价格却相对亲民。这种高性价比让我感到非常满意。
          </div>
        </div>
        <div class="row10-item" :style="{ '--count2': 7 }">
          <div class="row10-item-icon row10-item-icon7"></div>
          <div class="row10-item-text1">จุ๊บ惜情จุ๊บ</div>
          <div class="row10-item-text2">
            出差在外，还能随时管理公司的内网资源，这都要归功于节点小宝的异地组网功能。真心感谢节点小宝团队！
          </div>
        </div>
        <div class="row10-item" :style="{ '--count2': 8 }">
          <div class="row10-item-icon row10-item-icon8"></div>
          <div class="row10-item-text1">嘻嘻嘻啊</div>
          <div class="row10-item-text2">
            第一次上手 1
            分钟就搞定了内网穿透，比我煮泡面还快。在酒店用笔记本连公司电脑，文件拖过来秒传，甚至远程剪视频都不卡顿。
          </div>
        </div>
      </div>
      <div class="row10-slide-b">
        <div class="row10-item-b" :style="{ '--count3': 1 }">
          <div class="row10-item-b-icon"></div>
          <div class="row10-item-b-text1">似水流年</div>
          <div class="row10-item-b-text2">
            以前远程办公像渡劫，现在用节点小宝就像把公司电脑揣兜里。自定义域名 +
            零信任安全架构，让我彻底告别 U 盘拷贝和邮件传输的风险。
          </div>
        </div>
        <div class="row10-item-b" :style="{ '--count3': 2 }">
          <div class="row10-item-b-icon row10-item-b-icon2"></div>
          <div class="row10-item-b-text1">热心市民林先生</div>
          <div class="row10-item-b-text2">
            之前用别的远程软件连公司电脑传方案，连家里 NAS
            存的宝宝照片都不敢随便远程看，就怕有漏洞，换了节点小宝安全感拉满。
          </div>
        </div>
        <div class="row10-item-b" :style="{ '--count3': 3 }">
          <div class="row10-item-b-icon row10-item-b-icon3"></div>
          <div class="row10-item-b-text1">康先生</div>
          <div class="row10-item-b-text2">
            节点小宝 1 分钟就能配置好，不用学技术、不用装插件，Windows 和 iOS
            还能无缝切换。能远程解决的班，绝不浪费生命！
          </div>
        </div>
        <div class="row10-item-b" :style="{ '--count3': 4 }">
          <div class="row10-item-b-icon row10-item-b-icon4"></div>
          <div class="row10-item-b-text1">晴天</div>
          <div class="row10-item-b-text2">
            我一直以为小宝只是能NAS，远程访问数据，没想到电脑也可以远程访问和控制桌面，回去就试一下，做的功能越来越好了。
          </div>
        </div>
        <div class="row10-item-b" :style="{ '--count3': 5 }">
          <div class="row10-item-b-icon row10-item-b-icon5"></div>
          <div class="row10-item-b-text1">江南一棵树</div>
          <div class="row10-item-b-text2">
            强烈推荐节点小宝给所有需要远程管理的朋友。它的内网穿透功能真的太强大了，无论在哪里都能轻松访问公司内网。
          </div>
        </div>
        <div class="row10-item-b" :style="{ '--count3': 6 }">
          <div class="row10-item-b-icon row10-item-b-icon6"></div>
          <div class="row10-item-b-text1">Allen</div>
          <div class="row10-item-b-text2">
            昨天客户临时要方案，掏出手机唤醒公司电脑，通过节点小宝直接拖走
            Windows 里的文档，比同事帮我传还快。
          </div>
        </div>
        <div class="row10-item-b" :style="{ '--count3': 7 }">
          <div class="row10-item-b-icon row10-item-b-icon7"></div>
          <div class="row10-item-b-text1">起风了</div>
          <div class="row10-item-b-text2">
            高效、安全、稳定，这是我对节点小宝的评价。它不仅满足了我的工作需求，还给了我超出预期的体验，感谢节点小宝。
          </div>
        </div>
        <div class="row10-item-b" :style="{ '--count3': 8 }">
          <div class="row10-item-b-icon row10-item-b-icon8"></div>
          <div class="row10-item-b-text1">静思雅颂</div>
          <div class="row10-item-b-text2">
            上周出差手机又满了，酒店里远程连家里电脑照样一键备份，速度快到离谱关键照片直接传到我家电脑，不经过别人服务器比存在云里踏实。
          </div>
        </div>
      </div>
    </div>
    <div class="twh-row12">
      <div class="row12-title move">权威资质认证</div>
      <div class="row12-items move">
        <div class="row12-item">
          <div class="item-icon icon-01"></div>
          <div class="item-title">高新技术企业</div>
        </div>
        <div class="row12-item">
          <div class="item-icon icon-02"></div>
          <div class="item-title">专精特新企业</div>
        </div>
        <div class="row12-item">
          <div class="item-icon icon-03"></div>
          <div class="item-title">双软企业认证</div>
        </div>
        <div class="row12-item">
          <div class="item-icon icon-04"></div>
          <div class="item-title">ISO27001信息安全管理体系认证</div>
        </div>
        <div class="row12-item">
          <div class="item-icon icon-05"></div>
          <div class="item-title">创新型企业</div>
        </div>
      </div>
    </div>
    <div class="twh-row11">
      <div class="row11-icon move"></div>
      <div class="row11-btn move delay-100" @click="jumpDownload()">
        立即体验
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
  import Foot from '@/components/Foot.vue'
  import { mapActions } from 'vuex'

  export default {
    name: 'Home2',
    components: {
      Foot,
    },
    data: function () {
      return {
        tab: 1,
        text1: '',
        text1b: '节点小宝 远程助手',
        text1CharIndex: 0,
        text2: '',
        text2b: '一网连万物，远近皆自如',
        text2CharIndex: 0,

        text3: '',
        text3b: '无需配置',
        text3CharIndex: 0,
        typing3: false,
        text4: '',
        text4b: '轻松远程',
        text4CharIndex: 0,
        text5: '',
        text5b: '傻瓜式操作，一键搞定远程需求',
        text5CharIndex: 0,

        text6: '',
        text6b: '直连不限速',
        text6CharIndex: 0,
        typing6: false,
        text7: '',
        text7b: '纵享丝滑',
        text7CharIndex: 0,
        text8: '',
        text8b: '采用创新直连传输技术',
        text8CharIndex: 0,

        text9: '',
        text9b: '三重认证',
        text9CharIndex: 0,
        typing9: false,
        text10: '',
        text10b: '连接够安全',
        text10CharIndex: 0,
        text11: '',
        text11b: '一次一密、动态密钥双管齐下',
        text11CharIndex: 0,

        text12: '',
        text12b: '稳定链路',
        text12CharIndex: 0,
        typing12: false,
        text13: '',
        text13b: '连接可靠',
        text13CharIndex: 0,
        text14: '',
        text14b: '抗干扰、低延迟、速度快',
        text14CharIndex: 0,

        // 移除了 text15 相关数据，因为已经改为静态文字

        movetop6: false,
        row6Class: false,
        row6Class2: false,
        row6Class3: false,

        movetop4: false,
        row4tr: false,

        movetop5: false,
        row5tr: false,

        movetop7: false,
        row7tr: false,

        movetopChuanliu: false,
        chuanliuTr: false,
      }
    },
    methods: {
      ...mapActions(['sendLog']),
      goHelp: function () {
        this.sendLog(['PC_nav_clicked', '文档'])
        window.location.href = '/helpcenter_v3/'
      },
      tabClick: function (tab) {
        this.tab = tab
      },
      jumpDownload: function () {
        this.$router.push('download')
        this.sendLog(['PC_home_clicked', '立即体验'])
      },
      checkInView: function (animatedElements, animatedElementsMoveRight) {
        let _that = this
        _that.$store.state.homeScrollY = window.scrollY
        animatedElements.forEach((element) => {
          let elementTop = element.getBoundingClientRect().top
          let elementBottom = element.getBoundingClientRect().bottom
          let windowHeight =
            window.innerHeight || document.documentElement.clientHeight
          let isInView = elementTop < windowHeight - 100 && elementBottom > 0
          if (isInView) {
            element.classList.add('move-active')
          }
        })

        animatedElementsMoveRight.forEach((element) => {
          let elementTop = element.getBoundingClientRect().top
          let elementBottom = element.getBoundingClientRect().bottom
          let windowHeight =
            window.innerHeight || document.documentElement.clientHeight
          let isInView = elementTop < windowHeight - 100 && elementBottom > 0

          if (isInView) {
            if (!_that.typing3 && element.id == 'typing3') {
              _that.typing3 = true
              _that.type(3)
              setTimeout(function () {
                _that.type(4)
              }, 320)
              _that.type(5)
            }

            if (!_that.typing6 && element.id == 'typing6') {
              _that.typing6 = true
              _that.type(6)
              setTimeout(function () {
                _that.type(7)
              }, 400)
              _that.type(8)
            }

            if (!_that.typing9 && element.id == 'typing9') {
              _that.typing9 = true
              _that.type(9)
              setTimeout(function () {
                _that.type(10)
              }, 320)
              _that.type(11)
            }

            if (!_that.typing12 && element.id == 'typing12') {
              _that.typing12 = true
              _that.type(12)
              setTimeout(function () {
                _that.type(13)
              }, 320)
              _that.type(14)
            }
            // 移除了 typing15 的相关判断

            if (!_that.movetop6 && element.id == 'movetop6') {
              _that.movetop6 = true
              _that.row6Class = true
              setTimeout(function () {
                _that.row6Class2 = true
              }, 300)
              setTimeout(function () {
                _that.row6Class3 = true
              }, 600)
            }

            if (!_that.movetop4 && element.id == 'movetop4') {
              _that.movetop4 = true
              setTimeout(function () {
                _that.row4tr = true
              }, 100)
            }
            if (!_that.movetop5 && element.id == 'movetop5') {
              _that.movetop5 = true
              setTimeout(function () {
                _that.row5tr = true
              }, 100)
            }

            if (!_that.movetop7 && element.id == 'movetop7') {
              _that.movetop7 = true
              setTimeout(function () {
                _that.row7tr = true
              }, 100)
            }

            if (!_that.movetopChuanliu && element.id == 'movetopChuanliu') {
              _that.movetopChuanliu = true
              setTimeout(function () {
                _that.chuanliuTr = true
              }, 100)
            }
          }
        })
      },
      type: function (type) {
        let _that = this
        if (type == 1) {
          setTimeout(function () {
            if (_that.text1CharIndex < _that.text1b.length) {
              _that.text1 += _that.text1b.charAt(_that.text1CharIndex)
              _that.text1CharIndex++
              _that.type(1)
            }
          }, 50)
        } else if (type == 2) {
          setTimeout(function () {
            if (_that.text2CharIndex < _that.text2b.length) {
              _that.text2 += _that.text2b.charAt(_that.text2CharIndex)
              _that.text2CharIndex++
              _that.type(2)
            }
          }, 80)
        } else if (type == 3) {
          setTimeout(function () {
            if (_that.text3CharIndex < _that.text3b.length) {
              _that.text3 += _that.text3b.charAt(_that.text5CharIndex)
              _that.text3CharIndex++
              _that.type(3)
            }
          }, 80)
        } else if (type == 4) {
          setTimeout(function () {
            if (_that.text4CharIndex < _that.text4b.length) {
              _that.text4 += _that.text4b.charAt(_that.text4CharIndex)
              _that.text4CharIndex++
              _that.type(4)
            }
          }, 80)
        } else if (type == 5) {
          setTimeout(function () {
            if (_that.text5CharIndex < _that.text5b.length) {
              _that.text5 += _that.text5b.charAt(_that.text5CharIndex)
              _that.text5CharIndex++
              _that.type(5)
            }
          }, 80)
        } else if (type == 6) {
          setTimeout(function () {
            if (_that.text6CharIndex < _that.text6b.length) {
              _that.text6 += _that.text6b.charAt(_that.text6CharIndex)
              _that.text6CharIndex++
              _that.type(6)
            }
          }, 80)
        } else if (type == 7) {
          setTimeout(function () {
            if (_that.text7CharIndex < _that.text7b.length) {
              _that.text7 += _that.text7b.charAt(_that.text7CharIndex)
              _that.text7CharIndex++
              _that.type(7)
            }
          }, 80)
        } else if (type == 8) {
          setTimeout(function () {
            if (_that.text8CharIndex < _that.text8b.length) {
              _that.text8 += _that.text8b.charAt(_that.text8CharIndex)
              _that.text8CharIndex++
              _that.type(8)
            }
          }, 80)
        } else if (type == 9) {
          setTimeout(function () {
            if (_that.text9CharIndex < _that.text9b.length) {
              _that.text9 += _that.text9b.charAt(_that.text9CharIndex)
              _that.text9CharIndex++
              _that.type(9)
            }
          }, 80)
        } else if (type == 10) {
          setTimeout(function () {
            if (_that.text10CharIndex < _that.text10b.length) {
              _that.text10 += _that.text10b.charAt(_that.text10CharIndex)
              _that.text10CharIndex++
              _that.type(10)
            }
          }, 80)
        } else if (type == 11) {
          setTimeout(function () {
            if (_that.text11CharIndex < _that.text11b.length) {
              _that.text11 += _that.text11b.charAt(_that.text11CharIndex)
              _that.text11CharIndex++
              _that.type(11)
            }
          }, 80)
        } else if (type == 12) {
          setTimeout(function () {
            if (_that.text12CharIndex < _that.text12b.length) {
              _that.text12 += _that.text12b.charAt(_that.text12CharIndex)
              _that.text12CharIndex++
              _that.type(12)
            }
          }, 80)
        } else if (type == 13) {
          setTimeout(function () {
            if (_that.text13CharIndex < _that.text13b.length) {
              _that.text13 += _that.text13b.charAt(_that.text13CharIndex)
              _that.text13CharIndex++
              _that.type(13)
            }
          }, 80)
        } else if (type == 14) {
          setTimeout(function () {
            if (_that.text14CharIndex < _that.text14b.length) {
              _that.text14 += _that.text14b.charAt(_that.text14CharIndex)
              _that.text14CharIndex++
              _that.type(14)
            }
          }, 80)
        }
        // 移除了 type(15) 方法
      },
    },
    mounted() {
      this.sendLog(['PC_home_show', ''])

      let _that = this

      _that.type(1)
      setTimeout(function () {
        _that.type(2)
      }, 50)

      let animatedElements = document.querySelectorAll('.move')
      let animatedElementsMoveRight = document.querySelectorAll('.move-right')
      window.addEventListener('scroll', function () {
        _that.checkInView(animatedElements, animatedElementsMoveRight)
      })
    },
  }
</script>

<style scoped lang="less">
  .home {
    .chuanliu-row {
      height: 880px;
      width: 100%;
      padding-top: 78px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: url('../assets/v5/banner_3.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      overflow: hidden;
      position: relative;
      .chuanliu-row-title {
        color: #fff;
        text-align: center;
        font-family: 'Source Han Sans CN';
        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: 56px; /* 140% */
      }
      .chuanliu-text {
        color: #b1b5c4;
        text-align: center;
        font-family: 'Source Han Sans CN';
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top: 14px;
      }
      .player-img {
        width: 1100px;
        height: 450px;
        aspect-ratio: 22/9;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      .player-img.move {
        opacity: 0;
        transform: translateX(-50%) translateY(30px);
        transition: opacity 0.8s ease-out, transform 0.8s ease-out;
      }
      .player-img.move-active {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
      }
      .chuanliu-items {
        display: flex;
        gap: 20px;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 35px;
        .chuanliu-item {
          position: relative;
          top: 20px;
          opacity: 0;
          transition: opacity 0.8s ease-out, top 0.8s ease-out;
          display: flex;
          padding: 18px 0 23px 0;
          width: 230px;
          box-sizing: border-box;
          flex-shrink: 0;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 18px;
          border-radius: 16px;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          .chuanliu-item-icon {
            width: 48px;
            height: 48px;
          }
          .chuanliu-item-icon-1 {
            background-image: url('../assets/chuanliu_icon1.svg');
            background-repeat: no-repeat;
            background-size: 100%;
            background-position: center;
          }
          .chuanliu-item-icon-2 {
            background-image: url('../assets/chuanliu_icon2.svg');
            background-repeat: no-repeat;
            background-size: 100%;
            background-position: center;
          }
          .chuanliu-item-icon-3 {
            background-image: url('../assets/chuanliu_icon3.svg');
            background-repeat: no-repeat;
            background-size: 100%;
            background-position: center;
          }
          .chuanliu-item-icon-4 {
            background-image: url('../assets/chuanliu_icon4.svg');
            background-repeat: no-repeat;
            background-size: 100%;
            background-position: center;
          }
          .chuanliu-item-text {
            width: 186px;
            color: var(--00, #fff);
            text-align: center;
            font-family: 'Source Han Sans CN';
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
        }
        .chuanliu-item-tr {
          top: 0px;
          opacity: 1;
        }
        .chuanliu-item-tr2 {
          top: 0px;
          opacity: 1;
          transition-delay: 0.1s;
        }
        .chuanliu-item-tr3 {
          top: 0px;
          opacity: 1;
          transition-delay: 0.2s;
        }
        .chuanliu-item-tr4 {
          top: 0px;
          opacity: 1;
          transition-delay: 0.3s;
        }
      }
    }
    .twh-row1 {
      height: 960px;
      background-image: url('../assets/home/banner.jpg');
      background-size: 100%;
      background-repeat: no-repeat;
      .row1-main {
        position: relative;
        margin: 0 auto;
        padding-top: 1px;
        width: 1280px;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        .row1-text1 {
          margin-top: 153px;
          text-align: center;
          font-family: 'Source Han Sans CN';
          font-size: 60px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          background: linear-gradient(
            90deg,
            #adbeff 13.8%,
            #fff 38.15%,
            #fff 59.02%,
            #adbeff 83.36%
          );
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .row1-text5 {
          font-size: 48px;
          font-weight: 700;
          line-height: 72px;
          color: rgba(255, 255, 255, 1);
        }
        .row1-text2 {
          text-align: center;
          font-family: 'Source Han Sans CN';
          font-size: 60px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          background: linear-gradient(
            90deg,
            #adbeff 13.8%,
            #fff 38.15%,
            #fff 59.02%,
            #adbeff 83.36%
          );
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .row1-text3 {
          width: 1007px;
          margin-top: 20px;
          color: #b1b5c4;
          text-align: center;
          font-family: 'Source Han Sans CN';
          font-size: 20px;
          font-style: normal;
          font-weight: 400;
          line-height: 30px; /* 150% */
        }
        .row1-btn {
          margin-top: 48px;
          width: 220px;
          height: 64px;
          border-radius: 14.222px;
          background: #3960f9;
          box-shadow: 0 1.185px 2.37px -1.185px rgba(9, 6, 63, 0.4),
            0 0 0 1.185px #3960f9;
          line-height: 64px;
          color: #fff;
          font-family: 'Source Han Sans CN';
          font-size: 24px;
          font-style: normal;
          font-weight: 500;
          cursor: pointer;
          text-align: center;
        }
        .row1-btn:hover {
          opacity: 0.9;
        }
        .row1-text4 {
          margin-top: 24px;
          font-size: 20px;
          color: #777e90;
        }
        .row1-items {
          position: absolute;
          bottom: 90px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          gap: 24px;
          .row1-item {
            display: inline-block;
            text-align: center;
            display: flex;
            width: 300px;
            height: 140px;
            padding: 30px 0;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 16px;
            box-sizing: border-box;
            border-radius: 20px;
            border: 1px solid rgba(255, 255, 255, 0.08);
            background: rgba(255, 255, 255, 0.08);
            backdrop-filter: blur(10px);
            .row1-item-text1 {
              margin-top: 18px;
              margin-bottom: 6px;
              font-size: 16px;
              line-height: 24px;
              color: #fff;
            }
            .row1-item-text2 {
              .row1-item-text2s1 {
                display: inline-block;
                font-size: 32px;
                line-height: 32px;
                font-weight: 700;
                font-family: 'Arial', 'Helvetica', 'SimHei', sans-serif;
                color: #fff;
              }
              .row1-item-text2s2 {
                display: inline-block;
                font-size: 18px;
                line-height: 32px;
                font-weight: 500;
                color: #fff;
                font-family: 'Arial', 'Helvetica', 'SimHei', sans-serif;
                vertical-align: 1px;
              }
            }
            .row1-item-text3 {
              color: #fff;
              text-align: center;
              font-family: 'Source Han Sans CN';
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%; /* 27px */
            }
          }
        }
      }
    }
    .i2 {
      position: relative;
      overflow: hidden;
      margin-bottom: 103px;
      margin-top: 30px;
      height: 700px;
      width: 1280px;
      border-radius: 24px;
      transform: translateX(-50%);
      left: 50%;
      border: 1px solid #e6e8ec;
      background-color: #f7f9ff;
      background-image: url('../assets/home/banner_2.png');
      background-size: 1280px 700px;
      background-position: center;
      background-repeat: no-repeat;
      display: flex;
      flex-direction: column;
      align-items: center;
      .submit-btn {
        width: 163.448px;
        height: 55.862px;
        border-radius: 1033.448px;
        border: 1px solid #3772ff;
        background: #f7f8fa;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 6px;
        box-sizing: border-box;
        gap: 14px;
        margin-top: 47px;
        span {
          color: #3772ff;
          font-family: 'Source Han Sans CN';
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          line-height: 24.828px; /* 137.931% */
          letter-spacing: -0.36px;
        }
        img {
          width: 43px;
          height: 43px;
        }
        &:hover {
          cursor: pointer;
          background: #eaebecbb;
        }
      }
      .text1 {
        margin-top: 54px;
        color: #1d1f24;
        text-align: center;
        font-family: 'Source Han Sans CN';
        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: 56px; /* 140% */
      }
      .content {
        position: relative;
        margin: 0 auto;
        width: 657px;

        .text2 {
          color: #57576c;
          text-align: center;
          font-family: 'Source Han Sans CN';
          font-size: 24px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
        .text3 {
          margin-top: 14px;
          color: #585d6c;
          text-align: center;
          font-family: 'Source Han Sans CN';
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
        .more {
          margin-top: 22px;
          .more1 {
            display: inline-block;
            position: relative;
            margin-right: 86px;
            padding-top: 48px;
            font-size: 16px;
            line-height: 20px;
            color: #585d6c;
          }
          .more1::before {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%, 0);
            content: '';
            width: 36px;
            height: 36px;
            background-image: url('../assets/v5/icon1.svg');
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
          .more2::before {
            background-image: url('../assets/v5/icon2.svg');
          }
          .more3::before {
            background-image: url('../assets/v5/icon3.svg');
          }
          .more4::before {
            background-image: url('../assets/v5/icon4.svg');
          }
          .more4 {
            margin-right: 0;
          }
        }
      }
    }
    .twh-row2 {
      height: 320px;
      overflow: hidden;
      background-color: #fff;

      .row2-slide-a {
        --logo-width: 190px;
        --logo-width2: 200px;
        --logo-height: 72px;
        --logo-count: 10;
        --duration: 36s;
        width: 100%;
        margin-inline: auto;
        margin-top: 80px;
        position: relative;
        height: var(--logo-height);
        overflow: hidden;

        @keyframes slide {
          to {
            right: calc(var(--logo-width) * -1);
          }
        }
        .row2-item {
          position: absolute;
          right: calc(var(--logo-width2) * var(--logo-count));
          width: var(--logo-width);
          height: var(--logo-height);
          animation-name: slide;
          animation-duration: var(--duration);
          animation-timing-function: linear;
          animation-iteration-count: infinite;
          animation-delay: calc(
            var(--duration) / var(--logo-count) *
              (var(--logo-count) - var(--count)) * -1
          );

          box-sizing: border-box;
          border: 0.9px solid rgba(224, 227, 234, 1);
          border-radius: 12px;
          background-size: 100%;
          background-repeat: no-repeat;
          overflow: hidden;
          text-align: center;

          .row2-item-in {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 190px;
            max-width: 8vw;
            height: 72px;
            border-radius: 12px;
            background-position: center;
          }
          .row2-item1 {
            background-image: url('../assets/home/row2_1.svg');
          }
          .row2-item2 {
            background-image: url('../assets/home/row2_2.svg');
          }
          .row2-item3 {
            background-image: url('../assets/home/row2_3.svg');
          }
          .row2-item4 {
            background-image: url('../assets/home/row2_4.svg');
          }
          .row2-item5 {
            background-image: url('../assets/home/row2_5.svg');
          }
          .row2-item6 {
            background-image: url('../assets/home/row2_6.svg');
          }
          .row2-item7 {
            background-image: url('../assets/home/row2_7.svg');
          }
          .row2-item8 {
            background-image: url('../assets/home/row2_8.svg');
          }
          .row2-item9 {
            background-image: url('../assets/home/row2_9.svg');
          }
          .row2-item10 {
            background-image: url('../assets/home/row2_19.svg');
          }
        }
      }

      .row2-slide-b {
        --logo-width: 190px;
        --logo-width2: 200px;
        --logo-height: 72px;
        --logo-count: 10;
        --duration: 36s;
        width: 100%;
        margin-inline: auto;
        margin-top: 24px;
        position: relative;
        height: var(--logo-height);
        overflow: hidden;

        @keyframes slide-b {
          to {
            left: calc(var(--logo-width) * -1);
          }
        }
        .row2-item-b {
          position: absolute;
          left: calc(var(--logo-width2) * var(--logo-count));
          width: var(--logo-width);
          height: var(--logo-height);
          animation-name: slide-b;
          animation-duration: var(--duration);
          animation-timing-function: linear;
          animation-iteration-count: infinite;
          animation-delay: calc(
            var(--duration) / var(--logo-count) *
              (var(--logo-count) - var(--count)) * -1
          );

          box-sizing: border-box;
          border: 0.9px solid rgba(224, 227, 234, 1);
          border-radius: 12px;
          background-size: 100%;
          background-repeat: no-repeat;
          overflow: hidden;
          text-align: center;

          .row2-item-b-in {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 190px;
            max-width: 8vw;
            height: 72px;
            border-radius: 12px;
            background-position: center;
          }

          .row2-b-item1 {
            background-image: url('../assets/home/row2_10.svg');
          }
          .row2-b-item2 {
            background-image: url('../assets/home/row2_11.svg');
          }
          .row2-b-item3 {
            background-image: url('../assets/home/row2_12.svg');
          }
          .row2-b-item4 {
            background-image: url('../assets/home/row2_13.svg');
          }
          .row2-b-item5 {
            background-image: url('../assets/home/row2_14.svg');
          }
          .row2-b-item6 {
            background-image: url('../assets/home/row2_15.svg');
          }
          .row2-b-item7 {
            background-image: url('../assets/home/row2_16.svg');
          }
          .row2-b-item8 {
            background-image: url('../assets/home/row2_17.svg');
          }
          .row2-b-item9 {
            background-image: url('../assets/home/row2_18.svg');
          }
          .row2-b-item10 {
            background-image: url('../assets/home/row2_20.svg');
          }
        }
      }
    }
    .twh-row3 {
      height: 2500px;
      background-color: #f0f5ff;
      .row3-main {
        margin: 0 auto;
        padding-top: 1px;
        width: 1280px;
        height: 100%;
        box-sizing: border-box;
        .row3-item1 {
          margin-top: 70px;
          text-align: center;
          .row3-item1-text1 {
            font-size: 40px;
            font-weight: 700;
            line-height: 60px;
            color: var(--08, rgba(29, 31, 36, 1));
          }
          .row3-item1-text2 {
            margin-top: 8px;
            color: var(--04, rgba(119, 126, 144, 1));
            font-size: 24px;
            line-height: 36px;
          }
        }

        .row3-item {
          position: relative;
          margin-top: 50px;
          padding-left: 786px;
          padding-top: 103px;
          box-sizing: border-box;
          width: 100%;
          height: 500px;
          background-image: url('../assets/home/row3_1.png');
          background-size: 100%;
          background-repeat: no-repeat;
          .row3-left {
            position: absolute;
            left: 50px;
            top: 50px;
            width: 660px;
            height: 400px;
            background-image: url('../assets/home/row3_3.png');
            background-size: 100%;
            background-repeat: no-repeat;
          }
          .row3-left2 {
            background-image: url('../assets/home/row3_5.png');
          }

          .row3-texts-item1-text {
            background: linear-gradient(
              90deg,
              rgba(55, 114, 255, 1),
              rgba(15, 159, 255, 1)
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-size: 40px;
            font-weight: 900;
            line-height: 58px;
          }
          .row3-texts-item1-text2 {
            display: inline-block;
            margin-left: 12px;
            font-size: 40px;
            font-weight: 900;
            line-height: 50px;
            background: linear-gradient(90deg, rgba(29, 31, 36, 1));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          .row3-texts-item2 {
            margin-bottom: 24px;
            color: rgba(0, 0, 0, 1);
            font-size: 30px;
            font-weight: 400;
            line-height: 45px;
          }
          .row3-texts-item3 {
            position: relative;
            padding-left: 24px;
            color: rgba(119, 126, 144, 1);
            font-size: 16px;
            line-height: 30px;
          }
          .row3-texts-item3::before {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 5px;
            height: 5px;
            border-radius: 50%;
            content: '';
            background-color: rgba(119, 126, 144, 1);
          }
          .row3-right-btn {
            margin-top: 24px;
            width: 160px;
            height: 48px;
            border: 1px solid rgba(55, 114, 255, 1);
            border-radius: 8px;
            color: rgba(55, 114, 255, 1);
            font-size: 18px;
            font-weight: 500;
            line-height: 48px;
            text-align: center;
            cursor: pointer;
          }
          .row3-right-btn:hover {
            opacity: 0.9;
            background-color: rgba(55, 114, 255, 1);
            color: #fff;
          }
        }
        .row3-item-b {
          margin-top: 50px;
          padding-left: 80px;
          width: 100%;
          height: 500px;
          background-image: url('../assets/home/row3_2.png');
          background-size: 100%;
          background-repeat: no-repeat;

          .row3-right {
            position: absolute;
            right: 50px;
            top: 50px;
            width: 660px;
            height: 400px;
            background-image: url('../assets/home/row3_8.png');
            background-size: 100%;
            background-repeat: no-repeat;
          }

          .row3-right2 {
            background-image: url('../assets/home/row3_9.png');
          }
        }
      }
    }
    .twh-row4 {
      background-color: #ffffff;
      text-align: center;
      padding-top: 93px;
      box-sizing: border-box;
      .row4-title {
        margin-bottom: 55px;
        color: #1d1f24;
        text-align: center;
        font-family: 'Source Han Sans CN';
        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: 56px; /* 140% */
      }
      .row4-notice {
        color: #3772ff;
        text-align: center;
        font-family: 'Source Han Sans CN';
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding-bottom: 73px;
      }
      .row4-items {
        display: flex;
        gap: 16px;
        justify-content: center;
        padding-bottom: 43px;
        .row4-item {
          position: relative;
          top: 20px;
          opacity: 0;
          transition: opacity 0.8s ease-out, top 0.8s ease-out;
          display: flex;
          width: 180px;
          height: 210px;
          padding: 20px 30px 25px 30px;
          box-sizing: border-box;
          flex-direction: column;
          align-items: center;
          gap: 18px;
          border-radius: 24px;
          border: 1px solid #cfd3e0;
          .row4-icon {
            width: 120px;
            height: 120px;
            background-image: url('../assets/home/row3_nas.png');
            background-size: 100%;
            background-repeat: no-repeat;
          }
          .row4-icon2 {
            background-image: url('../assets/home/row3_win.png');
          }
          .row4-icon3 {
            background-image: url('../assets/home/row3_mac.png');
          }
          .row4-icon4 {
            width: 72px;
            background-image: url('../assets/home/row3_iphone.png');
          }
          .row4-icon5 {
            background-image: url('../assets/home/row3_ipad.png');
          }
          .row4-icon6 {
            background-image: url('../assets/home/row3_router.png');
          }
          .row4-icon7 {
            background-image: url('../assets/v5/linux.png');
          }
          .row4-icon8 {
            background-image: url('../assets/v5/docker.png');
          }
          .row4-text {
            color: #1d1f24;
            text-align: center;
            font-family: 'Source Han Sans CN';
            font-size: 18px;
            font-style: normal;
            font-weight: 500;
            line-height: 27px; /* 150% */
          }
        }
        .row4-item-last {
          margin-right: 0;
        }
        .row4-item-tr {
          top: 0px;
          opacity: 1;
        }
        .row4-item-tr2 {
          top: 0px;
          opacity: 1;
          transition-delay: 0.1s;
        }
        .row4-item-tr3 {
          top: 0px;
          opacity: 1;
          transition-delay: 0.2s;
        }
        .row4-item-tr4 {
          top: 0px;
          opacity: 1;
          transition-delay: 0.3s;
        }
        .row4-item-tr5 {
          top: 0px;
          opacity: 1;
          transition-delay: 0.4s;
        }
        .row4-item-tr6 {
          top: 0px;
          opacity: 1;
          transition-delay: 0.5s;
        }
        .row4-item-tr7 {
          top: 0px;
          opacity: 1;
          transition-delay: 0.6s;
        }
        .row4-item-tr8 {
          top: 0px;
          opacity: 1;
          transition-delay: 0.7s;
        }
      }
    }
    .twh-row5 {
      height: 800px;
      text-align: center;
      padding-top: 70px;
      box-sizing: border-box;
      background-color: rgba(29, 31, 36, 1);

      .row5-title {
        color: #ffffff;
        font-size: 40px;
        font-weight: 700;
        line-height: 56px;
      }
      .row5-text {
        margin-bottom: 50px;
        margin-top: 12px;
        color: rgba(255, 255, 255, 1);
        font-size: 24px;
        line-height: 36px;
      }
      .row5-items {
        text-align: center;
        .row5-item {
          position: relative;
          top: 20px;
          opacity: 0;
          transition: opacity 0.8s ease-out, top 0.8s ease-out;

          display: inline-block;
          width: 620px;
          height: 480px;
          border-radius: 24px;
          backdrop-filter: blur(10px);
          background: rgba(53, 57, 69, 0.5);
          overflow: hidden;

          .row5-item-text {
            margin-top: 35px;
            color: rgba(255, 255, 255, 1);
            font-size: 30px;
            font-weight: 700;
            line-height: 42px;
          }
          .row5-item-text2 {
            margin-top: 7px;
            color: rgba(255, 255, 255, 1);
            font-size: 18px;
            line-height: 27px;
          }
          .row5-item-icon {
            margin-top: 38px;
            width: 620px;
            height: 300px;
            background-image: url('../assets/home/row3_12.png');
            background-size: 100%;
            background-repeat: no-repeat;
          }
          .row5-item-icon2 {
            background-image: url('../assets/home/row3_11.png');
          }
        }
        .row5-item2 {
          margin-left: 40px;
        }
        .row5-item-tr {
          top: 0px;
          opacity: 1;
        }
        .row5-item-tr2 {
          top: 0px;
          opacity: 1;
          transition-delay: 0.2s;
        }
      }
    }
    .twh-row6 {
      height: 720px;
      text-align: center;
      padding-top: 70px;
      box-sizing: border-box;

      .row6-title {
        color: rgba(29, 31, 36, 1);
        font-size: 40px;
        font-weight: 700;
        line-height: 56px;
      }
      .row6-text {
        margin-bottom: 50px;
        margin-top: 12px;
        color: rgba(119, 126, 144, 1);
        font-size: 24px;
        line-height: 36px;
      }
      .row6-items {
        .row6-item {
          display: inline-block;
          position: relative;
          top: 20px;
          opacity: 0;
          transition: opacity 0.8s ease-out, top 0.8s ease-out;
          margin-right: 24px;
          width: 410px;
          height: 400px;
          border: 1px solid rgba(255, 255, 255, 1);
          border-radius: 24px;
          backdrop-filter: blur(10px);
          background: rgba(255, 255, 255, 0.8);
          overflow: hidden;
          text-align: left;
          box-shadow: 0 10px 30px 0 #e8efff;

          .row6-item-icon {
            width: 410px;
            height: 240px;
            background-image: url('../assets/home/row6_1.png');
            background-size: 100%;
            background-repeat: no-repeat;
          }
          .row6-item-icon2 {
            background-image: url('../assets/home/row6_2.png');
          }
          .row6-item-icon3 {
            background-image: url('../assets/home/row6_3.png');
          }
          .row6-item-text {
            margin-left: 32px;
            margin-top: 33px;
            color: rgba(29, 31, 36, 1);
            font-size: 30px;
            font-weight: 500;
            line-height: 42px;
          }
          .row6-item-text2 {
            margin-left: 32px;
            margin-top: 8px;
            color: rgba(119, 126, 144, 1);
            font-size: 16px;
            line-height: 25px;
            width: 346px;
          }
        }
        .row6-item-last {
          margin-right: 0;
        }
        .row6-item:hover {
          top: -10px;
          transition: top 0.3s ease-out;
        }
        .row6-item-tr {
          top: 0px;
          opacity: 1;
        }
      }
    }
    .twh-row7 {
      height: 760px;
      padding-top: 70px;
      background-image: url('../assets/home/row7_1.png');
      background-size: 100%;
      background-repeat: no-repeat;
      text-align: center;
      box-sizing: border-box;

      .row7-title {
        color: #ffffff;
        font-size: 40px;
        font-weight: 700;
        line-height: 56px;
      }
      .row7-text {
        margin-bottom: 50px;
        margin-top: 12px;
        color: rgba(255, 255, 255, 1);
        font-size: 24px;
        line-height: 36px;
      }

      .row7-items {
        .row7-item {
          position: relative;
          top: 20px;
          opacity: 0;
          transition: opacity 0.8s ease-out, top 0.8s ease-out;

          display: inline-block;
          margin-left: 40px;
          width: 620px;
          height: 420px;
          backdrop-filter: blur(4px);
          border-radius: 24px;
          background-image: linear-gradient(
            180deg,
            hsla(0, 0%, 100%, 0.1),
            hsla(0, 0%, 100%, 0)
          );
          overflow: hidden;

          .row7-item-text {
            margin-top: 35px;
            color: rgba(255, 255, 255, 1);
            font-size: 30px;
            font-weight: 700;
            line-height: 42px;
          }
          .row7-item-text2 {
            margin-top: 7px;
            color: rgba(255, 255, 255, 1);
            font-size: 18px;
            line-height: 27px;
          }
          .row7-item-icon {
            margin: 0 auto;
            margin-top: 40px;
            width: 440px;
            height: 270px;
            background-image: url('../assets/home/row7_2.svg');
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
          .row7-item-icon2 {
            margin: 0 auto;
            margin-top: 56px;
            width: 514px;
            height: 200px;
            background-image: url('../assets/home/row7_3.svg');
          }
        }
        .row7-item-tr {
          top: 0px;
          opacity: 1;
        }
        .row7-item-tr2 {
          top: 0px;
          opacity: 1;
          transition-delay: 0.2s;
        }
      }
    }
    .twh-row8 {
      height: 720px;
      text-align: center;
      padding-top: 70px;
      box-sizing: border-box;
      background-image: url('../assets/home/row8_7.png');
      background-size: 100%;
      background-repeat: no-repeat;

      .row8-title {
        color: rgba(29, 31, 36, 1);
        font-size: 40px;
        font-weight: 700;
        line-height: 56px;
      }
      .row8-tabs {
        margin-top: 38px;
        .row8-tab {
          margin-right: 102px;
          display: inline-block;
          cursor: pointer;
          width: 100px;
          height: 36px;
          color: rgba(29, 31, 36, 1);
          font-size: 16px;
          line-height: 36px;
        }
        .row8-tab-last {
          margin-right: 0;
        }
        .row8-tab-active {
          border-radius: 20px;
          background: rgba(29, 31, 36, 1);
          color: rgba(255, 255, 255, 1);
          font-weight: 500;
          transition: background 0.5s ease;
        }
      }
      .row8-item {
        margin-top: 40px;
        .row8-item-icon {
          display: inline-block;
          width: 720px;
          height: 400px;
          background-image: url('../assets/home/row8_1.png');
          background-size: 100%;
          background-repeat: no-repeat;
          border-radius: 24px;
          overflow: hidden;
        }
        .row8-item-icon2 {
          background-image: url('../assets/home/row8_2.png');
        }
        .row8-item-icon3 {
          background-image: url('../assets/home/row8_3.png');
        }
        .row8-item-icon4 {
          background-image: url('../assets/home/row8_4.png');
        }
        .row8-item-icon5 {
          background-image: url('../assets/home/row8_5.png');
        }
        .row8-item-icon6 {
          background-image: url('../assets/home/row8_6.png');
        }
        .row8-item-texts {
          position: relative;
          margin-left: 20px;
          display: inline-block;
          padding-left: 50px;
          width: 540px;
          height: 400px;
          border-radius: 24px;
          background: rgba(255, 255, 255, 1);
          vertical-align: top;
          text-align: left;
          box-sizing: border-box;

          .row8-item-text1 {
            margin-bottom: 15px;
            margin-top: 74px;
            color: rgba(29, 31, 36, 1);
            font-size: 30px;
            font-weight: 700;
            line-height: 42px;
          }
          .row8-item-text1-b {
            margin-top: 0;
            line-height: 30px;
          }
          .row8-item-text2 {
            color: rgba(119, 126, 144, 1);
            font-size: 18px;
            line-height: 30px;
          }
          .row8-item-btn {
            position: absolute;
            left: 50px;
            bottom: 86px;
            width: 160px;
            height: 44px;
            border-radius: 8px;
            background-color: #3772ff;
            text-align: center;
            line-height: 44px;
            color: rgba(255, 255, 255, 1);
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            text-decoration: none;
          }
          .row8-item-btn3 {
            bottom: 40px;
          }
          .row8-item-btn4 {
            bottom: 46px;
          }
          .row8-item-btn:hover {
            opacity: 0.9;
          }
        }
      }
    }
    .twh-row9 {
      width: 100%;
      height: 800px;
      background-color: #17171b;
      overflow: hidden;

      .row9-icon {
        margin: 0 auto;
        width: 1400px;
        height: 100%;
        background-image: url('../assets/home/row9_1.png');
        background-size: 100%;
        background-repeat: no-repeat;
        overflow: hidden;

        .row9-text1 {
          margin-top: 70px;
          text-align: center;
          font-size: 40px;
          line-height: 56px;
          font-weight: 700;
          color: #ffffff;
          -webkit-text-stroke: 0.5px #ffffff;
        }
        .row9-text2 {
          margin-top: 12px;
          text-align: center;
          font-size: 32px;
          line-height: 45px;
          font-weight: 700;
          color: #ffffff;
        }
        .row9-text3 {
          margin: 0 auto;
          margin-top: 22px;
          text-align: center;
          font-size: 20px;
          line-height: 28px;
          color: #ffffff;
        }
        .row9-text3-b {
          margin-top: 0;
        }
      }
    }
    .twh-row10 {
      height: 700px;
      box-sizing: border-box;
      padding-top: 70px;
      text-align: center;
      box-sizing: border-box;
      background-color: #ffffff;

      .row10-title {
        color: rgba(29, 31, 36, 1);
        font-size: 40px;
        font-weight: 700;
        line-height: 56px;
      }
      .row10-text {
        margin-bottom: 50px;
        margin-top: 12px;
        color: rgba(119, 126, 144, 1);
        font-size: 24px;
        line-height: 36px;
      }
      .row10-slide-a {
        --logo-width: 500px;
        --logo-width2: 470px;
        --logo-height: 160px;
        --logo-count: 8;
        --duration: 40s;
        width: 100%;
        margin-inline: auto;
        margin-top: 55px;
        position: relative;
        height: var(--logo-height);
        overflow: hidden;

        @keyframes row10slide {
          to {
            right: calc(var(--logo-width) * -1);
          }
        }

        .row10-item {
          position: absolute;
          padding-top: 22px;
          padding-left: 134px;
          right: calc(var(--logo-width2) * var(--logo-count));
          width: var(--logo-width);
          height: var(--logo-height);
          animation-name: row10slide;
          animation-duration: var(--duration);
          animation-timing-function: linear;
          animation-iteration-count: infinite;
          animation-delay: calc(
            var(--duration) / var(--logo-count) *
              (var(--logo-count) - var(--count2)) * -1
          );

          border: 1px solid rgba(229, 230, 235, 1);
          border-radius: 20px;
          box-sizing: border-box;
          overflow: hidden;
          text-align: left;

          .row10-item-icon {
            position: absolute;
            left: 30px;
            top: 38px;
            width: 85px;
            height: 85px;
            border-radius: 50%;
            overflow: hidden;
            background-image: url('../assets/home/row10_1.png');
            background-size: 100%;
            background-repeat: no-repeat;
          }
          .row10-item-icon2 {
            background-image: url('../assets/home/row10_2.png');
          }
          .row10-item-icon3 {
            background-image: url('../assets/home/row10_3.png');
          }
          .row10-item-icon4 {
            background-image: url('../assets/home/row10_4.png');
          }
          .row10-item-icon5 {
            background-image: url('../assets/home/row10_5.png');
          }
          .row10-item-icon6 {
            background-image: url('../assets/home/row10_6.png');
          }
          .row10-item-icon7 {
            background-image: url('../assets/home/row10_7.png');
          }
          .row10-item-icon8 {
            background-image: url('../assets/home/row10_8.png');
          }
          .row10-item-text1 {
            color: rgba(23, 23, 27, 1);
            font-size: 24px;
            font-weight: 700;
            line-height: 33px;
          }
          .row10-item-text2 {
            margin-top: 10px;
            width: 340px;
            color: rgba(87, 87, 108, 1);
            font-size: 16px;
            line-height: 22px;
          }
        }
      }
      .row10-slide-b {
        --logo-width: 500px;
        --logo-width2: 470px;
        --logo-height: 160px;
        --logo-count: 8;
        --duration: 40s;
        width: 100%;
        margin-inline: auto;
        margin-top: 30px;
        position: relative;
        height: var(--logo-height);
        overflow: hidden;

        @keyframes row10slide2 {
          to {
            left: calc(var(--logo-width) * -1);
          }
        }

        .row10-item-b {
          position: absolute;
          left: calc(var(--logo-width2) * var(--logo-count));
          padding-top: 22px;
          padding-left: 134px;
          width: var(--logo-width);
          height: var(--logo-height);
          animation-name: row10slide2;
          animation-duration: var(--duration);
          animation-timing-function: linear;
          animation-iteration-count: infinite;
          animation-delay: calc(
            var(--duration) / var(--logo-count) *
              (var(--logo-count) - var(--count3)) * -1
          );
          border: 1px solid rgba(229, 230, 235, 1);
          border-radius: 20px;
          box-sizing: border-box;
          overflow: hidden;
          text-align: left;

          .row10-item-b-icon {
            position: absolute;
            left: 30px;
            top: 38px;
            width: 85px;
            height: 85px;
            border-radius: 50%;
            overflow: hidden;
            background-image: url('../assets/home/row10_9.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
          .row10-item-b-icon2 {
            background-image: url('../assets/home/row10_10.png');
          }
          .row10-item-b-icon3 {
            background-image: url('../assets/home/row10_11.png');
          }
          .row10-item-b-icon4 {
            background-image: url('../assets/home/row10_12_1.png');
          }
          .row10-item-b-icon5 {
            background-image: url('../assets/home/row10_12.png');
          }
          .row10-item-b-icon6 {
            background-image: url('../assets/home/row10_13.png');
          }
          .row10-item-b-icon7 {
            background-image: url('../assets/home/row10_14.png');
          }
          .row10-item-b-icon8 {
            background-image: url('../assets/home/row10_15.png');
          }
          .row10-item-b-text1 {
            color: rgba(23, 23, 27, 1);
            font-size: 24px;
            font-weight: 700;
            line-height: 33px;
          }
          .row10-item-b-text2 {
            margin-top: 10px;
            width: 340px;
            color: rgba(87, 87, 108, 1);
            font-size: 16px;
            line-height: 22px;
          }
        }
      }
    }
    .twh-row11 {
      height: 240px;
      padding-top: 63px;
      box-sizing: border-box;
      background-image: url('../assets/home/row11_1.png');
      background-size: 100%;
      background-repeat: no-repeat;
      .row11-icon {
        margin: 0 auto;
        width: 330px;
        height: 50px;
        background-image: url('../assets/home/row11_2.svg');
        background-size: 100%;
        background-repeat: no-repeat;
      }
      .row11-btn {
        margin: 0 auto;
        margin-top: 24px;
        width: 140px;
        height: 40px;
        line-height: 40px;
        box-sizing: border-box;
        border: 1px solid rgba(55, 114, 255, 1);
        border-radius: 6px;
        color: rgba(55, 114, 255, 1);
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        cursor: pointer;
      }
      .row11-btn:hover {
        opacity: 0.9;
        background-color: rgba(55, 114, 255, 1);
        color: #fff;
      }
    }

    .twh-row12 {
      height: 500px;
      padding-top: 70px;
      text-align: center;
      box-sizing: border-box;
      background-color: #ffffff;

      .row12-title {
        color: rgba(29, 31, 36, 1);
        font-size: 40px;
        font-weight: 700;
        line-height: 56px;
      }

      .row12-items {
        display: flex;
        justify-content: space-between;
        width: 1248px;
        margin: 0 auto;
        margin-top: 65px;
        .row12-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 175px;
          text-align: center;
          .item-icon {
            width: 120px;
            height: 120px;
            fill: #fff;
            border-radius: 60px;
            box-shadow: 0px 10px 25px rgba(55, 114, 255, 0.15);
            background-size: 72px 72px;
            background-repeat: no-repeat;
            background-position: center center;
          }
          .icon-01 {
            background-image: url('../assets/home/row12-01.svg');
          }
          .icon-02 {
            background-image: url('../assets/home/row12-02.svg');
          }
          .icon-03 {
            background-image: url('../assets/home/row12-03.svg');
          }
          .icon-04 {
            background-image: url('../assets/home/row12-04.svg');
          }
          .icon-05 {
            background-image: url('../assets/home/row12-05.svg');
          }
          .item-title {
            color: #57576c;
            text-align: center;
            font-family: 'Source Han Sans CN';
            font-size: 20px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            margin-top: 30px;
          }
        }
      }
    }

    .twh-row13 {
      width: 100%;
      height: 720px;
      text-align: center;
      padding-top: 70px;
      box-sizing: border-box;
      background: linear-gradient(90deg, #f6f1ff 0%, #eff5ff 100%);

      .row13-title {
        color: rgba(29, 31, 36, 1);
        font-size: 40px;
        font-weight: 700;
        line-height: 56px;
      }
      .row13-text {
        margin-bottom: 50px;
        margin-top: 12px;
        color: rgba(119, 126, 144, 1);
        font-size: 24px;
        line-height: 36px;
      }

      .row13-body {
        width: 1380px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        .body-left {
          width: 680px;
          height: 390px;
          background-image: url('../assets/home/row13-left.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
        .body-right {
          width: 540px;
          height: 390px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          margin-left: 60px;
          gap: 24px;
          .right-item {
            display: flex;
            align-items: center;
            width: 420px;
            height: 72px;
            border-radius: 16px;
            padding-left: 20px;
            gap: 16px;
            background: linear-gradient(
              180deg,
              rgba(255, 255, 255, 0.8) 0%,
              rgba(255, 255, 255, 0) 100%
            );
            .item-icon-1 {
              width: 48px;
              height: 48px;
              background-size: 48px 48px;
              background-repeat: no-repeat;
              background-position: center center;
            }
            .item-icon {
              width: 48px;
              height: 48px;
              background-size: 48px 48px;
              background-repeat: no-repeat;
              background-position: center center;
              margin: 0 auto;
              margin-top: 20px;
              margin-bottom: 15px;
            }
            .icon-01 {
              background-image: url('../assets/home/row13-01.svg');
            }
            .icon-02 {
              background-image: url('../assets/home/row13-02.svg');
            }
            .icon-03 {
              background-image: url('../assets/home/row13-03.svg');
            }
            .icon-04 {
              background-image: url('../assets/home/row13-04.svg');
            }
            .item-title {
              color: #57576c;
              text-align: center;
              font-family: 'Source Han Sans CN';
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }
          }
        }
      }
    }

    .move {
      opacity: 0;
      transform: translateY(50px);
      transition: opacity 0.8s ease-out, transform 0.8s ease-out;
    }
    .move-active {
      opacity: 1;
      transform: translateY(0);
    }
    /* 为不同元素设置不同的延迟，创建层次感 */
    .delay-100 {
      transition-delay: 0.1s;
    }
    .delay-200 {
      transition-delay: 0.2s;
    }
    .delay-300 {
      transition-delay: 0.3s;
    }
  }
</style>
